import React from "react";
import { Layout } from "views/Main/Layouts";
import { useTranslation } from "utilities/i18n";
import { useUserMeta } from "utilities/userMeta";
import { useSelector } from "react-redux";
import { State } from "store";
import { InventoryView } from "generated/graphql";

const ProfileSettings: React.FC = () => {
  const { Content } = Layout;
  const { t } = useTranslation();

  const [setUserMeta] = useUserMeta();
  const defaultView = useSelector((state: State) => {
    return state.userMeta?.defaultInventoryView;
  });

  const setView = (view: InventoryView) => {
    setUserMeta({
      defaultInventoryView: view,
      inventorySessionState: view
    });
  };

  return (
    <Content details>
      <Content.Title>{t("SETTINGS")}</Content.Title>
      <div className="settings grid form">
        <div className="form-group">
          <p className="col-4 text-right top">{t("DEFAULT_INVENTORY_VIEW")}</p>
          <div className="col-4">
            <div className="form-input">
              <input
                type="radio"
                id="map"
                name={"defaultView"}
                value={"map"}
                defaultChecked={defaultView === InventoryView.Map}
                onClick={() => setView(InventoryView.Map)}
              />
              <label
                className="inline option inventory-view-option"
                htmlFor="map"
              >
                {t("MAP_VIEW")}
              </label>
              <br />
              <input
                type="radio"
                id="list"
                name={"defaultView"}
                value={"list"}
                defaultChecked={defaultView === InventoryView.List}
                onClick={() => setView(InventoryView.List)}
              />
              <label
                className="inline option inventory-view-option"
                htmlFor="list"
              >
                {t("LIST_VIEW")}
              </label>
            </div>
          </div>
        </div>
      </div>
    </Content>
  );
};

export default ProfileSettings;
